<template>
  <div>
    <ButtonMain
      class="button-main flex h-full w-full items-center justify-center"
      :variant="style"
      :disabled="disabled"
      @click="onPress"
    >
      <div
        v-if="status !== 'brokerPortal'"
        class="mr-2"
        v-html="icon"
      />
      <span :class="{ 'py-2 text-xs': isForMobile }">{{ description }}</span>
      <div
        v-if="status == 'brokerPortal'"
        v-html="icon"
      />
    </ButtonMain>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import ButtonMain from '@/components/ButtonMain.vue';

const brokerPortalIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path d="M12 6.39062H7C6.44772 6.39062 6 6.83834 6 7.39062V17.3906C6 17.9429 6.44772 18.3906 7 18.3906H17C17.5523 18.3906 18 17.9429 18 17.3906V12.3906" stroke="#F8C617" stroke-width="2"/>
    <path d="M18.1768 6.17237L13.5281 10.821M18.1768 6.17237L18.1768 9.82276M18.1768 6.17237L14.5264 6.17237" stroke="#F8C617" stroke-width="2"/>
  </svg>`;

const connectIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="11" viewBox="0 0 17 11" fill="none">
    <path d="M10.9257 10.3906H16.3409L12.3143 0.390625H9.60157L10.0748 3.96463H6.92236L7.39554 0.390625H4.68281L0.65625 10.3906H6.07141L6.54459 6.8179H10.4525L10.9257 10.3906Z" fill="white"/>
  </svg>`;

const props = defineProps({
  status: String,
  isForMobile: Boolean,
  disabled: Boolean,
});

const emits = defineEmits(['press']);

const onPress = () => {
  emits('press');
};

const buttonProps = computed(() => {
  const base = {
    style: 'yellow',
    description: 'Connect',
    icon: '',
  };

  switch (props.status) {
    case 'connect':
      return {
        ...base,
        style: 'yellow',
        description: 'Connect',
        icon: connectIcon,
      };
    case 'brokerPortal':
      return {
        ...base,
        style: 'light-yellow',
        description: 'Go To Broker Portal',
        icon: brokerPortalIcon,
      };
    case 'requestVerification':
      return {
        ...base,
        style: 'yellow',
        description: 'Request Verification',
        icon: connectIcon,
      };
    case 'connecting':
      return {
        ...base,
        style: 'light-white',
        description: 'Connecting',
        icon: connectIcon,
      };
    default:
      return base;
  }
});

const style = computed(() => buttonProps.value.style);
const description = computed(() => buttonProps.value.description);
const icon = computed(() => buttonProps.value.icon);
</script>

<style scoped>
.button-main {
  min-width: 200px;
  @apply cursor-pointer;
}
</style>
